import { render, staticRenderFns } from "./SpTabContent.vue?vue&type=template&id=2adc7f46&scoped=true&"
import script from "./SpTabContent.vue?vue&type=script&lang=js&"
export * from "./SpTabContent.vue?vue&type=script&lang=js&"
import style0 from "./SpTabContent.vue?vue&type=style&index=0&id=2adc7f46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adc7f46",
  null
  
)

export default component.exports